import { render, staticRenderFns } from "./destroy.vue?vue&type=template&id=741103c8"
import script from "./destroy.vue?vue&type=script&lang=js"
export * from "./destroy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports